var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({ padding: '0 1in' })},[_c('h1',[_vm._v("Sortable Lists")]),_c('A'),_c('B')],1)}
var staticRenderFns = []

export { render, staticRenderFns }